import * as React from 'react';
import { Component } from 'react';
import { parse } from 'query-string';
import Lazy from 'lazy.js';
import BPromise from 'bluebird';
import { History, Location } from 'history';
import {
  ColumnDefinition,
  getFilters2,
  getOrder,
  getSearchFilter,
  getSearchOrder,
  getServerFieldSectionWhere,
  getServerQueryFilter2,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION
} from 'Src/helpers/table/table';
import { DATE_INTERVAL, COUNT_INTERVAL, FILTER_TYPE, FIRST_PAGE, LIMIT } from 'Src/consts/table';
import { TRANSACTION_STATUS } from 'Src/consts/transaction';
import { getSelectOptionForPaymentStatus, getSelectOptionForClubStatus } from 'Src/helpers/table/select';
import { Loader } from 'Src/components/Loader/Loader';
import { SelectAllCheckbox } from 'Src/components/SelectAllCheckbox/SelectAllCheckbox';
import { AppUser } from 'Src/views/App/App';
// import { GenericSummary } from 'Src/components/GenericSummary/GenericSummary';
import { Grid2 } from 'Src/components/Grid/Grid2';
// import { TransactionSummary } from './TransactionSummary/TransactionSummary';
import { ResizablePanel } from 'Src/components/ResizablePanel/ResizablePanel';
import { Transaction } from 'Src/models/transaction';
import { getAllTransactions, getTransactions, getTransactionsCount } from 'Src/helpers/service/admin/transactions';
import { PaymentAccount } from 'Src/models/paymentAccount';
import {
  getTransactionAmount,
  getTransactionStatus,
  getTransactionClubStatus,
  getTransactionNameTournamentOrClub,
  getCreatedAt,
  getUpdatedAt
} from 'Src/helpers/accessor/accessor';
import { getPaymentAccount } from 'Src/helpers/service/admin/paymentAccounts';
import { refundTransaction } from 'Src/helpers/service/admin/transactions';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { ColumnToggleButton } from 'Src/components/ColumnToggleButton/ColumnToggleButton';
import { loadHiddenColumns, saveHiddenColumns } from 'Src/helpers/columnVisibility/columnVisibility';
import { DatePicker as SitDatePicker } from 'Src/components/DatePicker/DatePicker';
import { Pagination2 } from 'Src/components/Pagination/Pagination2';
import moment from 'moment';
import '../../BillingPayments.scss';
import {
  searchFunctionUsersByFirstName,
  searchFunctionUsersByLastName,
  searchFunctionUsersByEmail,
  searchFunctionStudentsByFirstName,
  searchFunctionStudentsByLastName,
  searchFunctionUserClubsByName,
  getFirstName,
  getLastName,
  getEmail,
  getClubName
} from 'Src/helpers/autocomplete/autocomplete';

const COLUMNS: ColumnDefinition[] = [
  {
    text: 'Amount',
    field: 'price',
    isSort: true,
    type: FILTER_TYPE.COUNT_INTERVAL,
    accessor: getTransactionAmount
  },
  {
    text: 'Status',
    field: 'status',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getTransactionStatus
  },
  {
    text: 'Last name',
    field: 'customerLastName',
    isSort: false,
    type: FILTER_TYPE.AUTOCOMPLETE,
    accessor: ['customerData', 'lastName']
  },
  {
    text: 'First name',
    field: 'customerFirstName',
    isSort: false,
    type: FILTER_TYPE.AUTOCOMPLETE,
    accessor: ['customerData', 'firstName']
  },
  {
    text: 'Email',
    field: 'customerEmail',
    isSort: false,
    type: FILTER_TYPE.AUTOCOMPLETE,
    accessor: ['customerData', 'email']
  },
  {
    text: 'Player last name',
    field: 'playerLastName',
    isSort: false,
    type: FILTER_TYPE.AUTOCOMPLETE,
    accessor: ['playerData', 'lastName']
  },
  {
    text: 'Player first name',
    field: 'playerFirstName',
    isSort: false,
    type: FILTER_TYPE.AUTOCOMPLETE,
    accessor: ['playerData', 'firstName']
  },
  {
    text: 'Club name',
    field: 'clubName',
    isSort: false,
    type: FILTER_TYPE.AUTOCOMPLETE,
    accessor: getTransactionNameTournamentOrClub
  },
  {
    text: 'Club status',
    field: 'clubStatus',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getTransactionClubStatus
  },
  {
    text: 'Created at',
    field: 'createdAt',
    isSort: true,
    type: FILTER_TYPE.DATE_INTERVAL,
    accessor: getCreatedAt
  },
  {
    text: 'Updated at',
    field: 'updatedAt',
    isSort: true,
    type: FILTER_TYPE.DATE_INTERVAL,
    accessor: getUpdatedAt
  }
];

const TRANSACTION_COLUMNS_VIEW_KEY = 'union.payments.transactions';
const DISPLAY_COLUMNS: ColumnDefinition[] = [
  { text: 'Payment', field: 'payment', isSort: false, type: FILTER_TYPE.NONE, accessor: ['payment'] },
  { text: 'Customer', field: 'customer', isSort: false, type: FILTER_TYPE.NONE, accessor: ['customer'] },
  { text: 'Player', field: 'player', isSort: false, type: FILTER_TYPE.NONE, accessor: ['player'] },
  { text: 'Club / event', field: 'club', isSort: false, type: FILTER_TYPE.NONE, accessor: ['club'] },
  { text: 'Status', field: 'status', isSort: false, type: FILTER_TYPE.NONE, accessor: ['status'] },
  { text: 'Created', field: 'created', isSort: false, type: FILTER_TYPE.NONE, accessor: ['created'] }
];

interface Props {
  user: AppUser;
  history: History;
  location: Location;
}

interface State {
  items: Transaction[];
  paymentAccount: PaymentAccount;
  currentPage: number;
  selectedItems: Transaction[];
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  isDataFiltered: boolean;
  filters: any;
  isLoading: boolean;
  isSelectAllChecked: boolean;
  total: number;
  basePath: string;
  autocompleteDefaultTexts: any;
  autocompleteSearchFunctions: any;
  autocompleteGetElementsTitles: any;
  isRefundConfirmationModalOpen: boolean;
  hiddenColumns: string[];
}

export class Transactions extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      paymentAccount: undefined,
      currentPage: FIRST_PAGE,
      selectedItems: [],
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      isDataFiltered: false,
      filters: {},
      isLoading: false,
      isSelectAllChecked: false,
      total: 0,
      basePath: '',
      autocompleteDefaultTexts: {
        customerFirstName: '',
        customerLastName: '',
        customerEmail: '',
        playerFirstName: '',
        playerLastName: '',
        clubName: ''
      },
      autocompleteSearchFunctions: {
        customerFirstName: this.getUsersByFirstName,
        customerLastName: this.getUsersByLastName,
        customerEmail: this.getUsersEmail,
        playerFirstName: this.getStudentsByFirstName,
        playerLastName: this.getStudentsByLastName,
        clubName: this.getClubs
      },
      autocompleteGetElementsTitles: {
        customerFirstName: getFirstName,
        customerLastName: getLastName,
        customerEmail: getEmail,
        playerFirstName: getFirstName,
        playerLastName: getLastName,
        clubName: getClubName
      },

      isRefundConfirmationModalOpen: false,
      hiddenColumns: loadHiddenColumns(props.user, TRANSACTION_COLUMNS_VIEW_KEY).filter(field => field !== 'payment')
    };
  }

  componentDidMount() {
    this.setState({
      isLoading: true
    });

    this.setAdditionalItems().then(paymentAccount => {
      this.setItems(paymentAccount);
    }).catch(() => {
      this.setState({ isLoading: false });
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        isLoading: true
      });
      this.setAdditionalItems().then(paymentAccount => {
        this.setItems(paymentAccount);
      }).catch(() => {
        this.setState({ isLoading: false });
      });
    }
  }

  getUsersByFirstName = (text: string) => {
    const { user } = this.props;

    return searchFunctionUsersByFirstName(user, text).then(users => {
      return Lazy(users)
        .uniq('firstName')
        .toArray();
    });
  };

  getUsersByLastName = (text: string) => {
    const { user } = this.props;

    return searchFunctionUsersByLastName(user, text).then(users => {
      return Lazy(users)
        .uniq('lastName')
        .toArray();
    });
  };

  getStudentsByFirstName = (text: string) => {
    const { user } = this.props;

    return searchFunctionStudentsByFirstName(user, text).then(users => {
      return Lazy(users)
        .uniq('firstName')
        .toArray();
    });
  };

  getStudentsByLastName = (text: string) => {
    const { user } = this.props;

    return searchFunctionStudentsByLastName(user, text).then(users => {
      return Lazy(users)
        .uniq('lastName')
        .toArray();
    });
  };

  getUsersEmail = (text: string) => {
    const { user } = this.props;

    return searchFunctionUsersByEmail(user, text);
  };

  getClubs = (text: string) => {
    const { user } = this.props;

    return searchFunctionUserClubsByName(user, text);
  };

  getPaymentAccountId(): string {
    const { history } = this.props;
    const search = parse(history.location.search);
    const paymentAccountId = search.paymentAccount;

    return Array.isArray(paymentAccountId) ? paymentAccountId[0] : paymentAccountId as string;
  }

  setAdditionalItems() {
    const { user, history } = this.props;
    const paymentAccountId = this.getPaymentAccountId();

    if (typeof paymentAccountId === 'undefined' || paymentAccountId === '') {
      history.replace('/school/settings/payment-accounts');
      return Promise.reject(new Error('Payment account is not selected'));
    }

    return getPaymentAccount(user, paymentAccountId).then(paymentAccount => {
      this.setState({
        paymentAccount: paymentAccount
      });
      return paymentAccount;
    });
  }

  setItems(paymentAccountArg?: PaymentAccount) {
    const { history, user } = this.props;
    const paymentAccount = paymentAccountArg || this.state.paymentAccount;

    if (typeof paymentAccount === 'undefined') {
      return Promise.resolve(false);
    }

    const search = parse(history.location.search);
    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection: TABLE_SORT_DIRECTION = '';
    let sortColumnsName = '';

    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortColumnsName !== '';
    const sortDirectionExist = sortDirection !== '';

    const filters = getFilters2(COLUMNS, search);

    const isShowFilter = false;
    const isDataFiltered = isFilterExist2(filters);

    const where = getServerFieldSectionWhere(filters);

    const order = sortByFieldExist && sortDirectionExist ? `${sortColumnsName} ${sortDirection}` : undefined;
    const serverQueryFilter = getServerQueryFilter2(page, where, order);

    const getItemsCountPromise = getTransactionsCount(user, paymentAccount.id, where);
    const getItemsPromise = getTransactions(user, paymentAccount.id, serverQueryFilter);
    const promises = [getItemsCountPromise, getItemsPromise];

    //TODO_004 backend must return {count: ...}
    return BPromise.all(promises).then(([count, transactions]) => {
      this.setState({
        currentPage: page,
        sortDirection: sortDirection,
        sortColumnsName: sortColumnsName,
        isShowFilter: isShowFilter,
        isDataFiltered: isDataFiltered,
        filters: filters,
        items: transactions,
        total: typeof count === 'number' ? count : count.count,
        basePath: history.location.pathname,
        isLoading: false,
        autocompleteDefaultTexts: {
          customerFirstName: filters.customerFirstName,
          customerLastName: filters.customerLastName,
          customerEmail: filters.customerEmail,
          playerFirstName: filters.playerFirstName,
          playerLastName: filters.playerLastName,
          clubName: filters.clubName
        }
      });
      return true;
    });
  }

  setCurrentPageParams = (currentPage: number): void => {
    const search = parse(this.props.history.location.search);
    let searchUpdated = [];

    searchUpdated.push(`paymentAccount=${search.paymentAccount}`);

    const { filters, sortColumnsName, sortDirection } = this.state;

    if (currentPage !== 1) {
      searchUpdated.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      searchUpdated.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      searchUpdated.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: searchUpdated.join('&')
    });
  };

  onItemClick = (index: number): void => {
    const { items, selectedItems } = this.state;
    const selectedTransaction = items[index];

    const selectedTransactionIndex = selectedItems.findIndex(transaction => selectedTransaction.id === transaction.id);
    let selectedTransactionsUpdated = [...selectedItems];

    if (selectedTransactionIndex !== -1) {
      selectedTransactionsUpdated.splice(selectedTransactionIndex, 1);
    } else {
      selectedTransactionsUpdated.push(selectedTransaction);
    }

    this.setState({
      selectedItems: selectedTransactionsUpdated
    });
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;

    const transactionsFiltered = items.filter(transaction => {
      return selectedItems.every(selectedTransaction => selectedTransaction.id !== transaction.id);
    });

    const selectedTransaction = [...selectedItems, ...transactionsFiltered];

    this.setState({
      selectedItems: selectedTransaction,
      isSelectAllChecked: true
    });
  };

  onSelectAllClick = (): void => {
    const { selectedItems, filters, paymentAccount } = this.state;

    this.setState({
      isLoading: true
    });

    const user = this.props.user;

    const where = getServerFieldSectionWhere(filters);

    getAllTransactions(user, paymentAccount.id, where).then(transactions => {
      const transactionsFiltered = transactions.filter(transaction => {
        return selectedItems.every(selectedTransaction => selectedTransaction.id !== transaction.id);
      });

      const selectedTransactions = [...selectedItems, ...transactionsFiltered];

      this.setState({
        selectedItems: selectedTransactions,
        isSelectAllChecked: true,
        isLoading: false
      });
    });
  };

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false
    });
  };

  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters, paymentAccount } = this.state;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search: string[] = [];
    search.push(`paymentAccount=${paymentAccount.id}&order=${sortField}:${order}`);

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.filters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = COLUMNS.find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      filters: nextFilters
    });
  };

  onApplyFilterClick = (): void => {
    const { filters, sortDirection, sortColumnsName, paymentAccount } = this.state;

    let search: string[] = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      isShowFilter: false
    });

    this.props.history.push({
      pathname: this.state.basePath,
      search: `paymentAccount=${paymentAccount.id}&${search.join('&')}`
    });
  };

  onClearFilterClick = (): void => {
    const { paymentAccount } = this.state;
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      isShowFilter: false,
      filters: {}
    });

    this.props.history.push({
      pathname: `/payments`,
      search: `paymentAccount=${paymentAccount.id}`
    });
  };

  onTableFilterClick = (event): void => {
    event.preventDefault();

    const isShowFilter = this.state.isShowFilter;

    this.setState({
      isShowFilter: !isShowFilter
    });
  };

  onCancelFilterClick = (): void => {
    this.setState({
      isShowFilter: false,
      filters: getFilters2(COLUMNS, parse(this.props.location.search || ''))
    });
  };

  onClearFilterDraftClick = (): void => {
    const customerEmail = this.state.filters.customerEmail || '';
    this.setState({ filters: customerEmail ? { customerEmail } : {} });
  };

  onColumnToggle = (field: string): void => {
    if (field === 'payment') return;
    const hiddenColumns = this.state.hiddenColumns.includes(field)
      ? this.state.hiddenColumns.filter(column => column !== field)
      : [...this.state.hiddenColumns, field];
    saveHiddenColumns(this.props.user, TRANSACTION_COLUMNS_VIEW_KEY, hiddenColumns);
    this.setState({ hiddenColumns });
  };

  onColumnsReset = (): void => {
    saveHiddenColumns(this.props.user, TRANSACTION_COLUMNS_VIEW_KEY, []);
    this.setState({ hiddenColumns: [] });
  };

  toggleMultiFilter = (field: string, value: string): void => {
    const currentValues = Array.isArray(this.state.filters[field])
      ? this.state.filters[field].map(String)
      : [];
    const nextValues = currentValues.includes(value)
      ? currentValues.filter(currentValue => currentValue !== value)
      : [...currentValues, value];
    this.setState({ filters: { ...this.state.filters, [field]: nextValues } });
  };

  setRangeFilter = (field: string, from: string, to: string): void => {
    this.setState({ filters: { ...this.state.filters, [field]: { from, to } } });
  };

  onTableAutocompleteFilterChange = (item, filterField: string): void => {
    let filterFieldUpdated;

    const isItemExist = typeof item !== 'undefined';

    switch (filterField) {
      case 'customerFirstName':
        filterFieldUpdated = 'firstName';

        break;

      case 'customerLastName':
        filterFieldUpdated = 'lastName';

        break;

      case 'customerEmail':
        filterFieldUpdated = 'email';

        break;

      case 'playerFirstName':
        filterFieldUpdated = 'firstName';

        break;

      case 'playerLastName':
        filterFieldUpdated = 'lastName';

        break;

      case 'clubName':
        filterFieldUpdated = 'name';

        break;

      default:
        filterFieldUpdated = filterField;
    }

    const filterValue = isItemExist ? item[filterFieldUpdated] : '';
    const filters = this.state.filters;

    let nextFilters = { ...filters };

    nextFilters = {
      ...nextFilters,
      [filterField]: filterValue
    };

    this.setState({
      filters: nextFilters
    });
  };

  onTabClick = (event, index: number) => {
    event.preventDefault();

    this.setState({
      total: index
    });
  };

  goBack = () => {
    this.props.history.push({
      pathname: '/school/settings/payment-accounts'
    });
  };

  // getSummaryTabs() {
  //   const { selectedItems, items } = this.state;

  //   switch (true) {
  //     case selectedItems.length === 1:
  //       return <TransactionSummary transaction={selectedItems[0]} />;
  //   }
  // }

  // renderSummary() {
  //   const { selectedItems } = this.state;
  //   const isOneItemSelected = selectedItems.length === 1;

  //   if (!isOneItemSelected) {
  //     return <div className="font-weight-bold">Select a transaction above</div>;
  //   }

  //   const summaryTabs = this.getSummaryTabs();

  //   return (
  //     <GenericSummary onTabClick={this.onTabClick} tabs={['Summary']} currentTabIndex={0}>
  //       {summaryTabs}
  //     </GenericSummary>
  //   );
  // }

  createRefund = () => {
    const { selectedItems, paymentAccount } = this.state;
    const { user } = this.props;
    const selectedItem = selectedItems[0];
    const { id: paymentItemId, paymentId, price } = selectedItem;

    this.setState({
      isLoading: true
    });

    refundTransaction(user, paymentAccount.id, paymentId, paymentItemId, price)
      .then(res => {
        const selecedItemUpdated = { ...selectedItem, status: TRANSACTION_STATUS.REFUND };

        this.setState({
          isRefundConfirmationModalOpen: false,
          selectedItems: [selecedItemUpdated]
        });

        this.setAdditionalItems().then(paymentAccount => {
          this.setItems(paymentAccount);
        });
      })
      .catch(error => {
        this.setState({
          isRefundConfirmationModalOpen: false,
          isLoading: false
        });
      });
  };

  onRefundClick = () => {
    this.setState({
      isRefundConfirmationModalOpen: true
    });
  };

  closeRefunConfirmationButton = () => {
    this.setState({
      isRefundConfirmationModalOpen: false
    });
  };

  renderRefundConfirmationModal() {
    const { isRefundConfirmationModalOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isRefundConfirmationModalOpen}
        title={'Refund payment'}
        body={`You are going to refund the selected payment. This action cannot be undone automatically. Are you sure?`}
        buttonText={'Refund'}
        onButtonClick={this.createRefund}
        buttonCancelText={'Cancel'}
        onCloseClick={this.closeRefunConfirmationButton}
      />
    );
  }

  renderStatusBadge(status: string): React.ReactNode {
    const statusText = status || 'Unknown';
    const normalized = statusText.toLowerCase();
    const isSuccess = normalized.indexOf('success') !== -1 || normalized.indexOf('paid') !== -1;
    const isWarning = normalized.indexOf('pending') !== -1 || normalized.indexOf('partial') !== -1;
    const className = isSuccess
      ? 'schoolBillingBadge schoolBillingBadge--success'
      : isWarning
        ? 'schoolBillingBadge schoolBillingBadge--warning'
        : 'schoolBillingBadge';

    return <span className={className}>{statusText}</span>;
  }

  renderSelectedToolbar(): React.ReactNode {
    const { selectedItems } = this.state;
    const isRefundActionActive =
      selectedItems.length === 1 &&
      (selectedItems[0].status === TRANSACTION_STATUS.SUCCESS ||
        selectedItems[0].status === TRANSACTION_STATUS.PARTIAL_REFUND);

    if (selectedItems.length === 0) {
      return null;
    }

    return (
      <div className="schoolBillingSelectionBar">
        <span>{selectedItems.length} selected</span>
        <button type="button" className="schoolBillingButton schoolBillingButton--danger" disabled={!isRefundActionActive} onClick={this.onRefundClick}>Refund</button>
        <button type="button" className="schoolBillingButton schoolBillingButton--secondary" onClick={this.onUnselectAllClick}>Clear selection</button>
      </div>
    );
  }

  renderPaymentsPagination(): React.ReactNode {
    const { currentPage, total } = this.state;

    return (
      <div className="schoolBillingPagination">
        <Pagination2
          currentPage={currentPage}
          setCurrentPageParams={this.setCurrentPageParams}
          total={total}
          modern={true}
        />
      </div>
    );
  }

  renderPaymentsTable(): React.ReactNode {
    const { items, selectedItems, isSelectAllChecked, hiddenColumns, currentPage, total } = this.state;
    const isColumnVisible = (field: string): boolean => field === 'payment' || !hiddenColumns.includes(field);

    if (items.length === 0) {
      return (
        <div className="schoolBillingEmptyState">
          <div className="schoolBillingEmptyIcon">£</div>
          <h3>No payments found</h3>
          <p>Payments matching this account and filter will appear here.</p>
        </div>
      );
    }

    return (
      <div className="schoolBillingTableWrap">
        <table className="schoolBillingTable schoolBillingPaymentsTable">
          <thead>
            <tr>
              <th className="schoolBillingCheckboxCell">
                <SelectAllCheckbox
                  compact
                  isChecked={isSelectAllChecked}
                  totalCount={total}
                  currentPage={currentPage}
                  pageItemsCount={items.length}
                  selectedItems={selectedItems}
                  onSelectAllOnPageClick={this.onSelectAllOnPageClick}
                  onSelectAllClick={this.onSelectAllClick}
                  onUnselectAllClick={this.onUnselectAllClick}
                />
              </th>
              {isColumnVisible('payment') && <th>Payment</th>}
              {isColumnVisible('customer') && <th>Customer</th>}
              {isColumnVisible('player') && <th>Player</th>}
              {isColumnVisible('club') && <th>Club / event</th>}
              {isColumnVisible('status') && <th>Status</th>}
              {isColumnVisible('created') && <th>Created</th>}
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => {
              const isSelected = selectedItems.some(selectedItem => selectedItem.id === item.id);
              const customerName = [item.customerData?.firstName, item.customerData?.lastName].filter(Boolean).join(' ') || '-';
              const playerName = [item.playerData?.firstName, item.playerData?.lastName].filter(Boolean).join(' ') || '-';
              const clubOrEvent = getTransactionNameTournamentOrClub(item) || '-';
              const clubStatus = getTransactionClubStatus(item);

              return (
                <tr key={item.id} className={isSelected ? 'schoolBillingRow schoolBillingRow--selected' : 'schoolBillingRow'} onClick={() => this.onItemClick(index)}>
                  <td className="schoolBillingCheckboxCell" onClick={event => event.stopPropagation()}>
                    <input type="checkbox" checked={isSelected} onChange={() => this.onItemClick(index)} />
                  </td>
                  {isColumnVisible('payment') && <td>
                    <div className="schoolBillingStrong">{getTransactionAmount(item)}</div>
                    <div className="schoolBillingMono">{item.paymentId || item.id}</div>
                  </td>}
                  {isColumnVisible('customer') && <td>
                    <div className="schoolBillingStrong">{customerName}</div>
                    {item.customerData?.email && <div className="schoolBillingMuted">{item.customerData.email}</div>}
                  </td>}
                  {isColumnVisible('player') && <td>{playerName}</td>}
                  {isColumnVisible('club') && <td>
                    <div className="schoolBillingStrong">{clubOrEvent}</div>
                    {clubStatus && <div className="schoolBillingMetaLine">{this.renderStatusBadge(clubStatus)}</div>}
                  </td>}
                  {isColumnVisible('status') && <td>{this.renderStatusBadge(getTransactionStatus(item))}</td>}
                  {isColumnVisible('created') && <td>
                    <div className="schoolBillingStrong">{getCreatedAt(item)}</div>
                    <div className="schoolBillingMuted">Updated {getUpdatedAt(item)}</div>
                  </td>}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
  render() {
    const {
      items,
      paymentAccount,
      selectedItems,
      isLoading,
      currentPage,
      total,
      isDataFiltered,
      isRefundConfirmationModalOpen,
      isShowFilter,
      filters,
      hiddenColumns
    } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    const classes = isRefundConfirmationModalOpen ? 'schoolBillingPage modal-open' : 'schoolBillingPage';
    const paidItems = items.filter(item => item.status === TRANSACTION_STATUS.SUCCESS);
    const refundedItems = items.filter(item => item.status === TRANSACTION_STATUS.REFUND || item.status === TRANSACTION_STATUS.PARTIAL_REFUND);
    const visibleTotal = items.reduce((sum, item) => sum + (Number(item.price) || 0), 0) / 100;
    const accountName = typeof paymentAccount !== 'undefined' ? paymentAccount.name : 'Payment account';
    const hasValue = (value: any): boolean => Array.isArray(value)
      ? value.length > 0
      : Boolean(value && (typeof value !== 'object' || Object.keys(value).some(key => Boolean(value[key]))));
    const filterCount = Object.keys(filters)
      .filter(field => field !== 'customerEmail' && hasValue(filters[field]))
      .length;
    const getRange = (field: string): { from?: string; to?: string } => {
      const value = filters[field];
      return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
    };
    const paymentStatusOptions = getSelectOptionForPaymentStatus();
    const clubStatusOptions = getSelectOptionForClubStatus();

    return (
      <div className={classes}>
        {this.renderRefundConfirmationModal()}

        <div className="schoolBillingIntro">
          <div>
            <h1>Payments</h1>
            <p>{accountName} payment history, refunds and payment status tracking.</p>
          </div>
          <div className="schoolBillingToolbarActions">
            <button type="button" className="schoolBillingButton schoolBillingButton--secondary" onClick={this.goBack}>Back to accounts</button>
          </div>
        </div>

        <div className="schoolBillingStats">
          <div className="schoolBillingStatCard">
            <div className="schoolBillingStatLabel"><span className="schoolBillingStatIcon">PAY</span>Payments</div>
            <div className="schoolBillingStatValue">{total}</div>
            <div className="schoolBillingStatHint">matching records</div>
          </div>
          <div className="schoolBillingStatCard">
            <div className="schoolBillingStatLabel"><span className="schoolBillingStatIcon">OK</span>Successful</div>
            <div className="schoolBillingStatValue">{paidItems.length}</div>
            <div className="schoolBillingStatHint">visible on this page</div>
          </div>
          <div className="schoolBillingStatCard">
            <div className="schoolBillingStatLabel"><span className="schoolBillingStatIcon">£</span>Page total</div>
            <div className="schoolBillingStatValue">£{visibleTotal.toFixed(2)}</div>
            <div className="schoolBillingStatHint">{refundedItems.length} refunded or partial</div>
          </div>
        </div>

        <section className="schoolBillingCard">
          <div className="schoolBillingToolbar">
            <div>
              <h2>Payments <span>{total}</span></h2>
              <p>{selectedItems.length > 0 ? `${selectedItems.length} selected` : 'Select one successful payment to refund it.'}</p>
            </div>
            <div className="schoolBillingToolbarActions">
              <button type="button" className="schoolBillingButton schoolBillingButton--secondary" onClick={this.onSelectAllOnPageClick}>Select page</button>
              <button type="button" className="schoolBillingButton schoolBillingButton--secondary" onClick={this.onUnselectAllClick} disabled={selectedItems.length === 0}>Clear selection</button>
            </div>
          </div>
          <div className="schoolBillingListControls">
            <label className="schoolBillingSearch">
              <input
                value={filters.customerEmail || ''}
                placeholder="Search customer email…"
                onChange={event => this.onTableFilterChange(event, 'customerEmail')}
                onKeyDown={event => event.key === 'Enter' && this.onApplyFilterClick()}
              />
              {filters.customerEmail ? (
                <button
                  type="button"
                  aria-label="Clear payment search"
                  onClick={() => this.setState({ filters: { ...filters, customerEmail: '' } }, this.onApplyFilterClick)}
                >
                  ×
                </button>
              ) : null}
            </label>
            <button
              type="button"
              className={`schoolBillingControlButton ${isShowFilter || filterCount > 0 ? 'is-active' : ''}`}
              onClick={this.onTableFilterClick}
            >
              <span className="schoolBillingControlButton__filter" aria-hidden="true" />
              Filters
              {filterCount > 0 ? <b>{filterCount}</b> : null}
            </button>
            <ColumnToggleButton
              columns={DISPLAY_COLUMNS}
              hiddenFields={new Set(hiddenColumns)}
              onToggle={this.onColumnToggle}
              isToggleable={field => field !== 'payment'}
              onReset={this.onColumnsReset}
            />
          </div>
          {this.renderSelectedToolbar()}
          <div className="schoolBillingCardBody">
            {this.renderPaymentsTable()}
          </div>
        </section>
        {this.renderPaymentsPagination()}

        {isShowFilter ? (
          <>
            <div className="schoolBillingFilterScrim" onClick={this.onCancelFilterClick} />
            <form
              className="schoolBillingFilters"
              onSubmit={event => {
                event.preventDefault();
                this.onApplyFilterClick();
              }}
            >
              <header>
                <strong>Filters</strong>
                <button type="button" onClick={this.onCancelFilterClick} aria-label="Close filters">×</button>
              </header>
              <div className="schoolBillingFilters__body">
                <fieldset>
                  <legend>Amount</legend>
                  <div className="schoolBillingFilterRange">
                    <label><span>From (£)</span><input type="number" min="0" step="0.01" value={getRange('price').from || ''} onChange={event => this.setRangeFilter('price', event.target.value, getRange('price').to || '')} /></label>
                    <label><span>To (£)</span><input type="number" min="0" step="0.01" value={getRange('price').to || ''} onChange={event => this.setRangeFilter('price', getRange('price').from || '', event.target.value)} /></label>
                  </div>
                </fieldset>
                <fieldset>
                  <legend>Payment status</legend>
                  <div className="schoolBillingFilterChips">
                    {paymentStatusOptions.map(option => {
                      const value = String(option.value);
                      const selected = (filters.status || []).map(String).includes(value);
                      return <button key={value} type="button" className={selected ? 'is-selected' : ''} aria-pressed={selected} onClick={() => this.toggleMultiFilter('status', value)}>{option.text}</button>;
                    })}
                  </div>
                </fieldset>
                <label><span>Customer first name</span><input value={filters.customerFirstName || ''} onChange={event => this.onTableFilterChange(event, 'customerFirstName')} /></label>
                <label><span>Customer last name</span><input value={filters.customerLastName || ''} onChange={event => this.onTableFilterChange(event, 'customerLastName')} /></label>
                <label><span>Player first name</span><input value={filters.playerFirstName || ''} onChange={event => this.onTableFilterChange(event, 'playerFirstName')} /></label>
                <label><span>Player last name</span><input value={filters.playerLastName || ''} onChange={event => this.onTableFilterChange(event, 'playerLastName')} /></label>
                <label><span>Club / event</span><input value={filters.clubName || ''} onChange={event => this.onTableFilterChange(event, 'clubName')} /></label>
                <fieldset>
                  <legend>Club status</legend>
                  <div className="schoolBillingFilterChips">
                    {clubStatusOptions.map(option => {
                      const value = String(option.value);
                      const selected = (filters.clubStatus || []).map(String).includes(value);
                      return <button key={value} type="button" className={selected ? 'is-selected' : ''} aria-pressed={selected} onClick={() => this.toggleMultiFilter('clubStatus', value)}>{option.text}</button>;
                    })}
                  </div>
                </fieldset>
                <SitDatePicker
                  label="Created at"
                  mode="range"
                  value={{
                    start: getRange('createdAt').from ? moment(getRange('createdAt').from, 'DD-MM-YYYY').toDate() : null,
                    end: getRange('createdAt').to ? moment(getRange('createdAt').to, 'DD-MM-YYYY').toDate() : null
                  }}
                  onChange={(range: any) => this.setRangeFilter(
                    'createdAt',
                    range && range.start ? moment(range.start).format('DD-MM-YYYY') : '',
                    range && range.end ? moment(range.end).format('DD-MM-YYYY') : ''
                  )}
                  format="DD-MM-YYYY"
                  clearable={true}
                  syncRangeOnSelect={true}
                />
              </div>
              <footer>
                <button type="button" className="is-clear" onClick={this.onClearFilterDraftClick}>Clear all</button>
                <div>
                  <button type="button" onClick={this.onCancelFilterClick}>Cancel</button>
                  <button type="submit" className="is-apply">Apply</button>
                </div>
              </footer>
            </form>
          </>
        ) : null}
      </div>
    );
  }
}


